import { useState, useEffect } from 'react';

export const useAustraliaUser = () => {
  const [isAustralia, setIsAustralia] = useState<boolean>(true); // optimistic default
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const cached = sessionStorage.getItem('rr_userCountry');
    if (cached) {
      setIsAustralia(cached === 'AU');
      setIsLoading(false);
      return;
    }
    fetch('https://api.country.is/')
      .then(res => res.json())
      .then((data: { country?: string }) => {
        const country = data.country ?? '';
        sessionStorage.setItem('rr_userCountry', country);
        setIsAustralia(country === 'AU');
      })
      .catch(() => {
        // Default true — AU-only site, safe assumption
        sessionStorage.setItem('rr_userCountry', 'AU');
        setIsAustralia(true);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { isAustralia, isLoading };
};
